/* Dreavaya cart drawer + slide-in panels. Reads the real cart from /cart.js; bundle savings come from Shopify automatic discounts. */
(function () {
  const dataEl = document.getElementById('DvCartData');
  if (!dataEl) return;
  const C = JSON.parse(dataEl.textContent);
  const T = {}; Object.keys(C.t).forEach((k) => { const d = document.createElement('textarea'); d.innerHTML = C.t[k]; T[k] = d.value; });
  const sized = (u, w) => !u ? '' : u + (u.includes('?') ? '&' : '?') + 'width=' + w;
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const fmt = (cents) => {
    try { return new Intl.NumberFormat(C.locale, { style: 'currency', currency: C.currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (s, map) => Object.keys(map).reduce((a, k) => a.split(k).join(map[k]), s);
  const fillW = (s, map) => String(s || '').replace(/\b[A-Z]\b/g, (c) => (c in map ? map[c] : c));  // whole-letter tokens only (prices contain '$')
  const pub = (n, d) => { try { if (window.DV && DV.track && DV.track.publish) DV.track.publish(n, d); } catch (e) {} };  // dv-track.js is absent on live pages
  const names = {}; Object.keys(C.seriesNames || {}).forEach((h) => { const d = document.createElement('textarea'); d.innerHTML = C.seriesNames[h]; names[h] = d.value; });
  const shortTitle = (t) => { const s = (C.titleSuffixes || []).reduce((a, x) => a.split(x).join(''), String(t || '')).trim(); return s || String(t || ''); };
  // book facts from the line: size from option1 (never the translated option name), N° code from the SKU (AG-A6-095 → AG-095)
  const bookInfo = (i) => {
    const ov = ((i.options_with_values || [])[0] || {}).value, m = /^(AG|HG)-(A6|A5)-(\d{3})$/.exec(i.sku || '');
    return { size: ov === 'A6' || ov === 'A5' ? ov : (m ? m[2] : (/-A5-/.test(i.sku || '') ? 'A5' : 'A6')), code: m ? m[1] + '-' + m[3] : '' };
  };

  /* ---------- estimated arrival: the promised 1–3 + 10–15 business days (C.eta = [11, 18]) shown as real dates ---------- */
  const addBiz = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
  const etaText = () => {
    if (!C.eta) return '';
    const now = new Date(), a = addBiz(now, C.eta[0]), b = addBiz(now, C.eta[1]);
    try { const f = new Intl.DateTimeFormat(C.locale, { month: 'short', day: 'numeric' }); return f.formatRange ? f.formatRange(a, b) : f.format(a) + ' – ' + f.format(b); }
    catch (e) { return ''; }
  };
  document.querySelectorAll('[data-dv-eta]').forEach((el) => { const t = etaText(); if (!t) return; el.textContent = t; const w = el.closest('[data-dv-eta-wrap]'); if (w) w.hidden = false; });

  /* ---------- panels (cart + menu) ---------- */
  let lastFocus = null;
  function openPanel(id) {
    const p = document.getElementById(id); if (!p) return;
    if (!p.classList.contains('is-open')) lastFocus = document.activeElement;  // adding from inside the open drawer keeps the original opener
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dv-lock');
    const f = p.querySelector('.dv-panel__sheet [data-dv-close], .dv-panel__sheet a, .dv-panel__sheet button');
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closePanel(p) {
    p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.dv-panel.is-open')) document.documentElement.classList.remove('dv-lock');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-dv-open]');
    if (opener) { e.preventDefault(); const id = opener.getAttribute('data-dv-open'); if (id === 'DvCart') refresh().then(() => openPanel(id)); else openPanel(id); return; }
    const closer = e.target.closest('[data-dv-close]');
    if (closer) { e.preventDefault(); closePanel(closer.closest('.dv-panel')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { const p = document.querySelector('.dv-panel.is-open'); if (p) closePanel(p); }
  });

  /* ---------- cart api ---------- */
  async function api(path, body) {
    const res = await fetch(root + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || T.error);
    return json;
  }
  // every cart write goes through one queue: two writes in flight (a quick add plus the attribution update) can make
  // Shopify keep only the later cart, which once dropped a book. Reads (cart.js) are not queued.
  let chain = Promise.resolve();
  function write(path, body) { const p = chain.then(() => api(path, body)); chain = p.catch(() => {}); return p; }
  let cart = null;
  async function refresh() {
    cart = await api('cart.js');
    render();
    document.querySelectorAll('[data-dv-cart-count]').forEach((b) => { b.textContent = cart.item_count || ''; b.setAttribute('data-count', cart.item_count); });
    document.dispatchEvent(new CustomEvent('dv:cart', { detail: cart }));
    return cart;
  }
  async function add(items, opts) {
    await write('cart/add.js', { items });
    await refresh();
    if (!opts || opts.open !== false) openPanel('DvCart');
  }
  async function change(key, quantity) {
    cart = await write('cart/change.js', { id: key, quantity });
    await refresh();
  }
  let noteTimer = null;
  function saveNote(v) { clearTimeout(noteTimer); noteTimer = setTimeout(() => write('cart/update.js', { note: v }).catch(() => {}), 600); }

  /* ---------- render ---------- */
  const bodies = () => document.querySelectorAll('[data-dv-cart-body]');
  const foots = () => document.querySelectorAll('[data-dv-cart-foot]');
  const countLabel = document.querySelector('[data-dv-count-label]');
  let body = null; let foot = null;

  /* ---------- recommendations: same series as the page → related to the newest book → best sellers (C.picks) ---------- */
  // Candidates are cached per source key (series / cart token + newest book) and filtered against the live cart on every render,
  // then topped up from C.picks so the row never runs short. DV.cat / DV_CTX only exist on dv-own pages (not on live checkout).
  const recMem = {}, recDone = { best: [] }; let recSeq = 0;  // best sellers are inline (C.picks): painted at once, no placeholders
  const ctx = () => window.DV_CTX || {};
  function recSource(books) {
    const x = ctx();
    if (x.series && window.DV && DV.cat && DV.cat.get) return { src: 'series', key: 'series|' + x.series, series: x.series };
    // cart.js lists the newest line first; the key carries language + currency because the session cache outlives a /ja-jp switch
    if (books.length) return { src: 'related', key: ['related', C.locale, C.currency, cart.token || '', books[0].product_id].join('|'), pid: books[0].product_id };
    return { src: 'best', key: 'best' };
  }
  function loadRecs(s) {
    if (recMem[s.key]) return recMem[s.key];
    let job = Promise.resolve([]);
    if (s.src === 'series') {
      job = DV.cat.get(s.series).then((d) => (d.items || []).filter((it) => it.av).sort((a, b) => (b.b ? 1 : 0) - (a.b ? 1 : 0))
        .map((it) => ({ id: it.d, v: it.v, v5: it.v5, ids: [it.d, it.v, it.v5], h: it.h, title: it.t, price: it.pr, img: it.i, img5: it.i5 || '', url: it.u })));
    } else if (s.src === 'related') {
      const sk = 'dvrec|' + s.key; let hit = null;
      try { hit = JSON.parse(sessionStorage.getItem(sk) || 'null'); } catch (e) {}
      job = hit ? Promise.resolve(hit) : fetch(root + 'recommendations/products.json?product_id=' + s.pid + '&limit=8&intent=related', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : {})).then((d) => {
          const list = (d.products || []).filter((p) => p.type === C.bookType).map((p) => {
            const vs = p.variants || [], v = vs.find((x) => x.available && x.option1 === 'A6') || vs.find((x) => x.available), v5 = vs.find((x) => x.available && x.option1 === 'A5');
            return v && { id: v.id, v: v.option1 === 'A6' ? v.id : 0, v5: v5 ? v5.id : 0, ids: vs.map((x) => x.id), h: p.handle, title: shortTitle(p.title), price: v.price, img: sized(p.featured_image, 300), url: p.url };
          }).filter(Boolean);
          try { sessionStorage.setItem(sk, JSON.stringify(list)); } catch (e) {}
          return list;
        });
    }
    return (recMem[s.key] = job.catch(() => []).then((l) => (recDone[s.key] = l)));
  }
  // an all-A5 cart is offered A5 books (designs with an A5 version first); any other cart gets each design's default size
  function recList(s, list, items) {
    const ids = new Set(items.map((i) => i.variant_id)), hs = new Set(items.map((i) => i.handle)), here = ctx().product, out = [];
    const bk = items.filter((i) => i.product_type === C.bookType), a5 = bk.length > 0 && bk.every((i) => bookInfo(i).size === 'A5');
    const take = (src) => (p) => {
      if (out.length < 3 && p && !hs.has(p.h) && p.h !== here && !(p.ids || [p.id]).some((id) => ids.has(id))) {
        const id = a5 && p.v5 ? p.v5 : p.id;
        // size of the copy this button adds (known when the source lists v / v5), so a mixed size is never silent
        out.push(Object.assign({ src }, p, { id, sz: id === p.v5 ? 'A5' : id === p.v ? 'A6' : '', want: a5 ? 'A5' : 'A6' }, id === p.v5 && p.img5 ? { img: p.img5 } : {}));  // an A5 rec shows the A5 front hs.add(p.h);
      }
    };
    const order = (l) => (a5 ? (l || []).slice().sort((x, y) => (y.v5 ? 1 : 0) - (x.v5 ? 1 : 0)) : l || []);  // stable: best-seller order kept within each group
    order(list).forEach(take(s.src)); order(C.picks).forEach(take('best'));
    return out;
  }
  const recHead = (s, out, dflt) => (s.src === 'series' && out.length && out[0].src === 'series' && names[s.series] ? fillW(T.recs_series, { S: names[s.series] }) : dflt);
  // fixed-size placeholders (same box as a card: square sleeve, 2-line name, button) so the drawer never jumps; &nbsp; because Dawn hides div:empty
  const recPh = '<div class="dv-card" aria-hidden="true"><div class="dv-sleeve"><div style="aspect-ratio:1/1;border-radius:3px;background:rgba(75,43,37,.07)">&nbsp;</div></div><div class="dv-card__name" style="font-size:1.2rem;min-height:2.9rem">&nbsp;</div><div class="dv-btn2" style="min-height:3.4rem;font-size:1.2rem;border-style:dashed;opacity:.3">&nbsp;</div></div>';
  function recCards(out) {
    return out.map((p) => `
      <div class="dv-card">
        <a class="dv-sleeve" href="${esc(p.url)}"><img src="${esc(p.img)}" alt="${esc(p.title)}" loading="lazy" width="300" height="300"></a>
        <div class="dv-card__name" style="font-size:1.2rem;min-height:2.9rem;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden">${p.sz && p.sz !== p.want ? `<span style="font-weight:700;font-size:1rem;color:#8A5634">${p.sz}</span> ` : ''}${esc(p.title)}</div>
        <button type="button" class="dv-btn2" style="min-height:3.4rem;font-size:1.2rem;padding:0 .6rem" data-dv-add="${p.id}" data-dv-rec="${esc(p.src)}">${esc(fill(T.add_price, { X: fmt(p.price) }))}</button>
      </div>`).join('');
  }
  function recBlock(items, books, head, id) {
    const s = recSource(books), out = recDone[s.key] ? recList(s, recDone[s.key], items) : null;
    return `<div class="dv-cart__recs"${id ? ` id="${id}"` : ''}${out && !out.length ? ' hidden' : ''}><div class="dv-cart__recs-head"><span class="dv-hand" data-dv-recs-head data-d="${esc(head)}">${esc(out ? recHead(s, out, head) : head)}</span><a href="${esc(C.collectionUrl)}">${esc(T.see_all)}</a></div>
        <div class="dv-cart__recs-grid" data-dv-recs>${out ? recCards(out) : recPh + recPh + recPh}</div></div>`;
  }
  function fillRecs() {
    const items = cart.items || [], s = recSource(items.filter((i) => i.product_type === C.bookType)), seq = ++recSeq;
    if (recDone[s.key]) return;  // already painted in the same pass
    loadRecs(s).then((list) => {
      if (seq !== recSeq) return;
      const out = recList(s, list, cart.items || []);
      document.querySelectorAll('[data-dv-recs]').forEach((g) => {
        const w = g.closest('.dv-cart__recs'), h = w && w.querySelector('[data-dv-recs-head]');
        g.innerHTML = recCards(out);
        if (w) w.hidden = !out.length;
        if (h) h.textContent = recHead(s, out, h.getAttribute('data-d'));
      });
    });
  }

  function render() {
    bodies().forEach((b, i) => { body = b; foot = foots()[i]; renderOne(); });
    if (cart) fillRecs();
  }
  function renderOne() {
    if (!body || !foot) return;
    const items = cart.items || [];
    countLabel.textContent = items.length ? fill(T.count, { X: cart.item_count }) : '';
    const books = items.filter((i) => i.product_type === C.bookType);
    const n = books.reduce((s, i) => s + i.quantity, 0);
    const inCart = new Set(items.map((i) => i.variant_id));

    if (!items.length) {
      foot.hidden = true;
      body.innerHTML = `
        <div class="dv-cart__empty">
          <div class="dv-sleevepage dv-cart__empty-pockets">
            <div class="dv-pocket">+</div><div class="dv-pocket">+</div><div class="dv-pocket">+</div><div class="dv-pocket">+</div>
            <img src="${esc(C.peek)}" alt="" aria-hidden="true" class="dv-cart__peek">
          </div>
          <h3 class="dv-q">${esc(T.empty_title)}</h3>
          <div class="dv-hand" style="font-size:2rem">${esc(T.empty_sub)}</div>
          <a class="dv-btn" href="${esc(C.collectionUrl)}" style="width:100%;margin-top:1.6rem">${esc(T.shop_all)}</a>
          <div class="dv-cart__fine">${T.empty_note}</div>
        </div>
        ${recBlock(items, books, T.recs_start, '')}`;
      return;
    }

    // fill-a-page pockets: the first four covers in the cart
    const thumbs = [];
    books.forEach((b) => { for (let k = 0; k < b.quantity && thumbs.length < 4; k++) thumbs.push(sized(b.image, 240)); });
    const full = n >= 4; const need = Math.max(0, 4 - n);
    const unit = books.length ? books[0].original_price : 0;
    // per-book price of a full page; Shopify rounds each line's % discount down, so this matches the cart ($26.23, same as the pocket bar)
    const each4 = unit - Math.floor(unit * (C.tierOff[4] || 0) + 1e-6);
    let nudge = T.nudge_empty;
    if (n > 0) nudge = full ? T.nudge_full : fillW(T.nudge_each, { X: need, P: fmt(each4) });
    const pageTxt = n === 0 ? '' : (full ? (n > 4 ? fill(T.page_full_extra, { X: n - 4 }) : T.page_full) : fill(T.pockets_of, { X: n }));
    const rot = ['-2deg', '1.5deg', '-1deg', '2deg'];
    const pockets = [0, 1, 2, 3].map((k) => thumbs[k]
      ? `<div class="dv-sleeve" style="aspect-ratio:3/4;padding:.4rem"><img src="${esc(thumbs[k])}" alt="" style="height:100%;object-fit:cover;transform:rotate(${rot[k]})"></div>`
      : `<div class="dv-sleeve" style="aspect-ratio:3/4;padding:.4rem"><div class="dv-pocket" style="position:absolute;inset:.4rem">+</div></div>`).join('');

    const lines = items.map((i) => {
      // books: short design name + "A6 · hand-size · N° AG-095"; other lines unchanged
      const bk = i.product_type === C.bookType ? bookInfo(i) : null;
      const title = bk ? shortTitle(i.product_title) : i.product_title;
      const sub = bk ? [bk.size === 'A5' ? T.size_a5 : T.size_a6, bk.code ? 'N° ' + bk.code : ''].filter(Boolean).join(' · ') : '';
      return `
      <div class="dv-cart__line">
        <div class="dv-polaroid" style="flex:none;width:6.4rem;transform:rotate(-1.5deg)"><img src="${esc(sized(i.image, 160))}" alt="" width="64" height="64" style="aspect-ratio:1/1;object-fit:cover"></div>
        <div class="dv-cart__line-main">
          <div class="dv-cart__line-top"><a class="dv-q" href="${esc(i.url)}">${esc(title)}</a><span>${fmt(i.original_line_price)}</span></div>
          <div class="dv-cart__line-sub">${esc(sub)}</div>
          <div class="dv-cart__line-qty">
            <button type="button" class="dv-step" data-dv-qty="${esc(i.key)}" data-q="${i.quantity - 1}" aria-label="${esc(T.dec)}">−</button>
            <span>${i.quantity}</span>
            <button type="button" class="dv-step" data-dv-qty="${esc(i.key)}" data-q="${i.quantity + 1}" aria-label="${esc(T.inc)}">+</button>
            <button type="button" class="dv-cart__remove" data-dv-qty="${esc(i.key)}" data-q="0">${esc(T.remove)}</button>
          </div>
        </div>
      </div>`;
    }).join('');

    const kitIn = C.kit && inCart.has(C.kit.id);
    const hasA6 = books.some((b) => bookInfo(b).size === 'A6');  // the refill kit only fits A6 rings
    const kit = C.kit && !kitIn && hasA6 ? `
      <div class="dv-cart__kit">
        <img src="${esc(C.kit.img)}" alt="" width="50" height="50">
        <div><strong>${esc(T.kit_title)}</strong> · ${fmt(C.kit.price)}<br><span>${esc(T.kit_sub)}</span></div>
        <button type="button" class="dv-btn" style="min-height:3.6rem;padding:0 1.4rem;font-size:1.25rem" data-dv-add="${C.kit.id}">${esc(T.add)}</button>
      </div>` : '';

    body.innerHTML = `
      <div class="dv-sleevepage dv-cart__page">
        <div class="dv-pg__head"><span class="dv-label">${esc(T.fill_label)}</span><span class="dv-label">${esc(pageTxt)}</span></div>
        <div class="dv-cart__pockets">${pockets}</div>
        <div class="dv-cart__nudge">
          <span class="dv-hand" style="color:${full ? 'var(--dv-green)' : 'var(--dv-rust)'}">${esc(nudge)}</span>
          ${!full && n > 0 ? `<a href="#DvCartRecs" class="dv-cart__pick">${esc(fill(T.pick_more, { X: need }))}</a>` : ''}
        </div>
        ${full ? `<div class="dv-seal dv-seal--gold" style="right:-.4rem;bottom:-1.4rem;width:6.4rem;height:6.4rem"><img src="${esc(C.sealGold)}" alt=""><span>PAGE<br>FULL</span></div>` : ''}
      </div>
      <div class="dv-cart__lines">${lines}</div>
      ${kit}
      ${recBlock(items, books, full ? T.recs_next : T.recs_fill, 'DvCartRecs')}
      <details class="dv-cart__gift"${cart.note ? ' open' : ''}><summary>${esc(T.gift)}</summary>
        <textarea data-dv-note placeholder="${esc(T.gift_ph)}" aria-label="${esc(T.gift)}">${esc(cart.note || '')}</textarea></details>`;

    // totals straight from Shopify (includes automatic bundle discounts)
    // add-on-only items (handle contains "add-on"/"addon", e.g. the A5 cover) need an order of addonMin+ to check out
    const hasAddon = cart.items.some((i) => /(^|-)add-?on(-|$)/.test(i.handle || ''));
    const addonGap = hasAddon && C.addonMin ? Math.max(0, C.addonMin - cart.total_price) : 0;
    const save = cart.original_total_price - cart.total_price;
    const ship = C.freeShipMin === null ? '' : (cart.total_price >= C.freeShipMin
      ? `<div class="dv-cart__ok"><span>✓ ${esc(T.free_ship)}</span><span>${fmt(0)}</span></div>${C.country === 'US' || (C.country === 'JP' && T.remote_note_jp) ? `<div class="dv-cart__fine" style="text-align:left;margin:0">${esc(C.country === 'JP' ? T.remote_note_jp : T.remote_note)}</div>` : ''}`
      : `<div class="dv-cart__fine" style="text-align:left;margin:0">${esc(fill(T.ship_gap, { X: fmt(C.freeShipMin - cart.total_price) }))}</div>`);
    foot.hidden = false;
    foot.innerHTML = `
      ${save > 0 ? `<div class="dv-cart__ok"><span>✓ ${esc(T.bundle_applied)}</span><span>−${fmt(save)}</span></div>` : ''}
      ${ship}
      ${etaText() ? `<div class="dv-cart__fine" style="text-align:left;margin:0">✈ ${esc(fill(T.eta, { X: etaText() }))}</div>` : ''}
      <div class="dv-cart__total"><span>${esc(T.total)}</span><span>${save > 0 ? `<s>${fmt(cart.original_total_price)}</s>` : ''}<strong class="dv-q">${fmt(cart.total_price)}</strong></span></div>
      ${addonGap > 0
        ? `<div class="dv-cart__block" role="alert">${esc(fill(T.addon_block, { AMT: fmt(C.addonMin), LEFT: fmt(addonGap) }))}</div><div class="dv-cart__ctas"><a href="${esc(C.collectionUrl)}" class="dv-btn" style="flex:1">${esc(T.shop_all)}</a></div>`
        : `<div class="dv-cart__ctas"><a href="${esc(C.checkoutUrl)}" class="dv-btn" style="flex:1.5">${esc(T.checkout)}</a><a href="${esc(C.checkoutUrl)}?payment=shop_pay" class="dv-btn dv-btn--shoppay" style="flex:1">Shop Pay</a></div>`}
      <div class="dv-cart__fine">${esc(T.secure)}</div>`;
  }

  document.addEventListener('click', (e) => {
    const q = e.target.closest('button[data-dv-qty][data-q]');  // only the cart's −/+/remove buttons (the live page has its own <strong data-dv-qty> counter)
    if (q) { e.preventDefault(); q.disabled = true; change(q.getAttribute('data-dv-qty'), parseInt(q.getAttribute('data-q'), 10)).catch((err) => alert(err.message)); return; }
    const a = e.target.closest('[data-dv-add]');
    if (a && !a.closest('form')) {
      e.preventDefault(); a.disabled = true; const src = a.getAttribute('data-dv-rec');
      add([{ id: parseInt(a.getAttribute('data-dv-add'), 10), quantity: 1 }]).then(() => { if (src) pub('dv_cart_rec_add', { source: src }); })
        .catch((err) => alert(err.message)).finally(() => { a.disabled = false; });
    }
  });
  document.addEventListener('input', (e) => { if (e.target.matches('[data-dv-note]')) saveNote(e.target.value); });

  if (document.querySelector('[data-dv-cart-page]')) refresh().catch(() => {});
  window.DV = Object.assign(window.DV || {}, { cart: { add, refresh, write, open: () => refresh().then(() => openPanel('DvCart')), fmt }, openPanel, closePanel });
})();
